import React, {Component} from 'react';
import ButtonConfirmDelete from './ButtonConfirmDelete'

class StationButtonDelete extends Component {
  render() {
    const {station, onDelete} = this.props
    const content = `Chắc chắn xoá trạm ${station.Name}?`
    return <ButtonConfirmDelete title="Xoá trạm" content={content} object={station} onOk={onDelete}/>
  }
}

export default StationButtonDelete;



// WEBPACK FOOTER //
// ./src/components/StationButtonDelete.js